export const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const SET_ORGANIZATION_ID = "SET_ORGANIZATION_ID";
export const SET_ORGANIZATION_INVITES = "SET_ORGANIZATION_INVITES";
export const SET_INVITES = "SET_INVITES";
